import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const deleteBooking = async (id: string) => {
  const resp = await api.delete(`/bookings/${id}`);
  queryClient.invalidateQueries(["bookings"]);

  return resp;
};
